import React from 'react';
import type { ExtraConfig } from '@gov-nx/core/app';
import { useLocale } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useProfilROSContextInstance } from '@gov-nx/module/page';
import {
	ContentLayout,
	ErrorStatusBanner,
	InfoBanner,
	LayoutGap,
} from '@gov-nx/ui/web';
import { ProfileContentLayout } from '../profil-ROB/ProfileContentLayout';
import { PFOListView } from './PFOListView';
import { POListView } from './POListView';
import { PersonInvolmentListView } from './PersonInvolmentListView';
import { ProfilROSSkeleton } from './ProfilROSSkeleton';

type ProfileRosViewConfig =
	ExtraConfig['profileRoutes']['rosConfig']['profileRosView'];

export interface RegistrOsobFormProps extends ProfileRosViewConfig {
	navigation: React.ReactNode;
	code: PageCode;
}

export const ProfileROSView = ({
	navigation,
	code,
	...ProfileRosViewConfig
}: RegistrOsobFormProps) => {
	const { extendedData, PFOData, controls } = useProfilROSContextInstance();
	const { t } = useLocale(code);

	if (controls.initialLoading) {
		return (
			<ContentLayout customClasses="pt-4!">
				{navigation}
				<ProfilROSSkeleton />
			</ContentLayout>
		);
	}

	if (controls.initialError) {
		return (
			<ContentLayout customClasses="pt-4!">
				{navigation}
				<ErrorStatusBanner code={code} />
			</ContentLayout>
		);
	}
	return (
		<ProfileContentLayout {...ProfileRosViewConfig.profileContentLayout}>
			{navigation}
			{Array.isArray(extendedData) && extendedData.length > 0 ? (
				<LayoutGap gap="xl">
					{ProfileRosViewConfig.isDescriptionVisible ? (
						<p className="text-body-s! text-(--text-secondary)">
							{t('zaznam.udaje-ros-text')}
						</p>
					) : null}

					<PFOListView
						code={code}
						PFOData={PFOData}
						{...ProfileRosViewConfig.PFOListView}
					/>
					<POListView />
					<PersonInvolmentListView />
				</LayoutGap>
			) : (
				<InfoBanner
					headline={t('stav.chyba.slozka-je-prazdna')}
					text={t('stav.chyba.nenasli-jsme-zadne-udaje')}
				/>
			)}
		</ProfileContentLayout>
	);
};
